import { render } from "./UserProfileDropdown.vue?vue&type=template&id=3faced6f&scoped=true&ts=true"
import script from "./UserProfileDropdown.vue?vue&type=script&lang=ts"
export * from "./UserProfileDropdown.vue?vue&type=script&lang=ts"

import "./UserProfileDropdown.vue?vue&type=style&index=0&id=3faced6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3faced6f"]])

export default __exports__